<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex xs12>
        <event-list></event-list>
      </v-flex>

      <v-btn
          color="red"
          dark
          fixed
          bottom
          right
          fab
          @click="$router.push('/admin/events/create')"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import EventListComponent from '../../components/admin/EventList.vue';

export default {
  components: {
    'event-list': EventListComponent
  }
}
</script>
